module.exports = __webpack_public_path__ + "media/bgm_main_jp.3adfa302.aac";